import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, HostListener, Inject, Input, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { catchError, forkJoin, Observable, of, switchMap, tap } from 'rxjs';
import { SpostaDocumentoRequest } from 'src/app/common/models/documento/sposta-documento-request';
import { CensimentoDocumenti } from 'src/app/common/models/sezioni/sezione-censimento-documenti/censimento-documenti';
import { HelpersService } from '../../../../core/services/helpers.service';
import { ModalNotifyService } from "../../../../core/services/modal-notify.service";
import { OperationsService } from '../../../../core/services/operations.service';
//import { Observable } from '@angular/common/src/facade/async';
import { NomiDescrittoriSezione } from '../../../configuration/nomi-descrittori-sezione';
import { DocumentoAddFormAbstractComponent } from '../../../form/documento/documento-add-form-abstract.component';
import { BeneficiarioPagamento } from '../../../models/beneficiario-pagamento';
import { DocumentoAllegato } from '../../../models/documento-allegato';
import { DataInput } from '../../../models/dto/data-input';

import { FileUploadResponse } from '../../../models/dto/file-upload-response';
import { UpdateMetadatiDocumentoRequest } from '../../../models/dto/update-metadati-documento-request';
import { tipiBeneficiarioPagamentoOptions } from '../../../models/tipologiche/mock-tipo-beneficiario';
import { FileFolders } from "../../fascicolo/documentazione-allegata-view/documentazione-allegata.component";
import { SpinnerService } from '../../spinner-load/spinner.service';
import { FileManagerService } from 'src/app/core/components/upload-tool/services/file-manager.service';
import { ConfigurationService } from 'src/app/common/configuration/services/configuration.service';
import { ConfigurationFeature } from 'src/app/common/configuration/models/configuration';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { UploadDocumentUtilityService } from 'src/app/common/form/documento/document-uploaded/upload-document-utility.service';

declare var closeModal: any;
declare var recuperaTokenCSRF;

@Component({
  selector: '[doc_add_form]',
  styleUrls: ['./documento-add-form.component.css'],
  templateUrl: '../../../form/documento/documento-add-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class DocumentoAddForm extends DocumentoAddFormAbstractComponent {

  @Output() private filesChangeEmiter: EventEmitter < any > = new EventEmitter();
  @Output() onReturnCallback = new EventEmitter();

  @Input() entityList: Array < any > = [];
  @Input() sezione: any;

  @Input() fileUploaded: boolean;

  loading: boolean = false;
  @Input() itemSelected: FileFolders|null = null;
  itemSelectedCorrente: FileFolders | null = null;


  static ToolTipElement;


  // private loading:boolean = false;
  fascicolo: any;
  praticaId:string;
  public isMain: boolean = true;
  refDocumentale: string;
  urlAddDocToSezione: string;
  esn: string;
  element;
  sezioneId: string;
  fascicoloId: string;
  controparte: boolean = false;
  datiPignoramento: boolean = false;
  patologia: boolean = false;
  schedaRecupero: boolean = false;
  schedaEsecuzione: boolean = false;
  altraparte: boolean = false;
  legaleIncaricato: boolean = false;
  scadenza: boolean = false;
  atto: boolean = false;
  esito: boolean = false;
  parcella: boolean = false;
  fattura: boolean = false;
  pagamento: boolean = false;
  incasso: boolean = false;
  provaScritta: boolean = false;
  titoloEsecutivo: boolean = false;
  beneImmobile: boolean = false;
  beneMobile: boolean = false;
  formTitle: string;
  sezioneForMetadati: any;
  beneficiarioPagamento: BeneficiarioPagamento = new BeneficiarioPagamento();
  nomeResponse: string;
  isSezioneDatiGen: boolean;
  fileList: any = [];
  fileToUpload: any;
  XSRF: string;
  fileUploadedName: string;
  urlUploadDocumento: string;
  public files: any[] = [];
  valid_files: any[] = [];
  typeCheck: boolean = false;

  isSpostaDoc: boolean = false;
  urlSpostaDoc: string = '/rs/ops/gp/documento';
  requestSpostaDoc: SpostaDocumentoRequest;


  isOcrEnable = false;



  constructor(@Inject(HttpClient) httpService: HttpClient,
              @Inject(OperationsService) operationService: OperationsService,
              @Inject(FormBuilder) campiForm: FormBuilder,
              @Inject(HelpersService) helpers: HelpersService,
              @Inject(DialogRef) dialogRef: DialogRef,
              private spinner: SpinnerService,
              private modalNotifyService: ModalNotifyService,
              private http: HttpClient ,
              private fileManager: FileManagerService,
              private configService : ConfigurationService,
              public viewManager: ViewManagerService,
              public uploadUtilityService: UploadDocumentUtilityService) {
    super(operationService, campiForm, helpers, httpService,dialogRef,viewManager,uploadUtilityService);
    this.fileList = new Array < any > ();
    /*this.getCanali();
    this.getTitolario();*/
    this.isOcrEnable = configService.isFeatureEnabled(ConfigurationFeature.OCR);
  }
  onFilesChange(fileList: Array < File > ) {
    this.fileList = fileList;
  }

  resetEntityBoolean() {
    this.controparte = false;
    this.patologia = false;
    this.schedaRecupero=false;
    this.schedaEsecuzione=false;
    this.altraparte = false;
    this.legaleIncaricato = false;
    this.scadenza = false;
    this.atto = false;
    this.esito = false;
    this.parcella = false;
    this.fattura = false;
    this.pagamento = false;
    this.incasso = false;
    this.provaScritta = false;
    this.titoloEsecutivo = false;
    this.beneImmobile = false;
    this.beneMobile = false;
    this.datiPignoramento = false;
  }



  buildForm(
    url: string,
    sezione: any,
    fascicoloId: string,
    isMain: boolean,
    esn: string,
    formTitle: string,
    addDocToEntity: boolean,
    entity,
    fascicolo: any,
    isSpostaDoc?: boolean,
    requestSpostaDoc?: SpostaDocumentoRequest,
    fileList?: DocumentoAllegato[],
    itemSelected?: FileFolders,
    separatorePathLogico?: string,
    isFolder?: boolean,
    documento?: DocumentoAllegato,
    tipoPratica?: string,
    isCensimentoDocumenti: boolean = false,
    requestCensimentoDocumenti: CensimentoDocumenti = null
  ) {
    this.fascicolo = fascicolo;
    this.praticaId = fascicolo.praticaBase.id;
    this.isSpostaDoc = isSpostaDoc;
    this.requestSpostaDoc = requestSpostaDoc;
    this.formTitle = formTitle;
    this.fileUploadList = fileList;
    this.itemSelected = itemSelected;
    this.separatorePathLogico = separatorePathLogico;
    this.isFolder = isFolder;
    this.documento = documento;
    this.tipoPratica = tipoPratica;
    this.isCensimentoDocumenti = isCensimentoDocumenti;
    this.requestCensimentoDocumenti = requestCensimentoDocumenti;
    this.resetEntityBoolean();
    if (esn === NomiDescrittoriSezione.SEZIONE_DATI_PIGNORAMENTO_FASCICOLO) {
      this.datiPignoramento = true;
      this.nomeResponse = 'datiPignoramento';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO) {
      this.controparte = true;
      this.nomeResponse = 'controparte';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_PATOLOGIE) {
      this.patologia = true;
      this.nomeResponse = 'patologia';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_SCHEDE_RECUPERO_FASCICOLO) {
      this.schedaRecupero = true;
      this.nomeResponse = 'schedaRecupero';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_SCHEDE_ESECUZIONE_FASCICOLO) {
      this.schedaEsecuzione = true;
      this.nomeResponse = 'schedaEsecuzione';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO) {
      this.altraparte = true;
      this.nomeResponse = 'altraParte';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_LEGALI_FASCICOLO) {
      this.legaleIncaricato = true;
      this.nomeResponse = 'legaleIncaricato';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_TITOLI_ESECUTIVI) {
      this.titoloEsecutivo = true;
      this.nomeResponse = 'titoloEsecutivo';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO) {
      this.scadenza = true;
      this.nomeResponse = 'scadenza';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO) {
      this.atto = true;
      this.nomeResponse = 'atto';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_ESITI_FASCICOLO) {
      this.esito = true;
      this.nomeResponse = 'esito';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_PARCELLE) {
      this.parcella = true;
      this.nomeResponse = 'parcella';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_FATTURE_FASCICOLO) {
      this.fattura = true;
      this.nomeResponse = 'fattura';
    }

    if (esn === NomiDescrittoriSezione.SEZIONE_INCASSI_FASCICOLO) {
      this.incasso = true;
      this.nomeResponse = 'incasso';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_PROVE_SCRITTE) {
      this.provaScritta = true;
      this.nomeResponse = 'provaScritta';
    }

    if (esn === NomiDescrittoriSezione.SEZIONE_BENI_IMMOBILI_FASCICOLO) {
      this.beneImmobile = true;
      this.nomeResponse = 'beneImmobile';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_BENI_MOBILI_FASCICOLO) {
      this.beneMobile = true;
      this.nomeResponse = 'beneMobile';
    }
    if (esn === NomiDescrittoriSezione.SEZIONE_PAGAMENTI_FASCICOLO) {
      this.pagamento = true;
      this.nomeResponse = 'pagamento';
      if (entity) {
        if (entity.controparte) {
          this.beneficiarioPagamento.idParent = entity.controparte.id;
          this.beneficiarioPagamento.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => {
            return tB.id === '1';
          })[0];
          this.beneficiarioPagamento.persona = entity.controparte.parte;
        }
        if (entity.legaleIncaricato) {
          this.beneficiarioPagamento.idParent = entity.legaleIncaricato.id;
          this.beneficiarioPagamento.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => {
            return tB.id === '2';
          })[0];
          this.beneficiarioPagamento.persona = entity.legaleIncaricato.legale;
        }
        if (entity.altraParte) {
          this.beneficiarioPagamento.idParent = entity.altraParte.id;
          this.beneficiarioPagamento.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => {
            return tB.id === '3';
          })[0];
          this.beneficiarioPagamento.persona = entity.altraParte.parte;
        }
      }
    }
    this.isMain = isMain;
    this.secondStep = isMain;
    this.urlAddDocToSezione = url;
    this.esn = esn;
    if(esn ==='SezioneDocumentazioneAllegata' && (isFolder === false || isFolder === null )){
      this.secondStep = false;
    }
    this.sezioneId = sezione.id;
    this.fascicoloId = fascicoloId;
    this.getTipiProvenienza();
    this.getTipiDocumento();
    this.getTipiVisibilitaDocumento();
    if (addDocToEntity) {
      this.getEntity(entity);
    }
    this.createForm(entity);
  }

  getEntity(entity) {
    if(this.isSpostaDoc){
      this.requestSpostaDoc.idEntita=entity.id;
      this.operationService.updateSezioneDocumento(this.requestSpostaDoc, this.urlSpostaDoc).subscribe(response=>{
        this.responseSpostaDoc(response);
      })
    } else {
      if(this.formRequest && entity.tipoAtto){
        this.provenienzaAtto = entity.provenienza;
          this.helperServices.getTipoDocumenteFromTipoAtto(entity.tipoAtto.label).subscribe(res => {
            this.tipoAtto = res[0];
            this.formRequest.tipoDocumento = this.tipoAtto;
          })
          this.formRequest.provenienza = this.provenienzaAtto;
          console.log(this.formRequest)

      }else{
        this.tipoAtto = null;
        this.provenienzaAtto = null;
      }
        this.secondStep = true;
        this.element = entity;
    }
  }

  annulla(){
    this.createForm();
    closeModal('docAddModal');
    this.onReturnCallback.emit(null);
  }

  confermaSpostaDoc(){
    this.requestSpostaDoc.idEntita = this.sezioneId ? this.sezioneId : 'new';
    this.requestSpostaDoc.idFascicolo=this.fascicoloId;
    this.operationService.updateSezioneDocumento(this.requestSpostaDoc, this.urlSpostaDoc).subscribe(response=>{
      this.responseSpostaDoc(response);
    });
  }

  responseSpostaDoc(response){
    if(response.returnCode === 'OK'){
      this.onReturnSpostaDoc.emit(response);
    }
  }

  deleteFile(index: number) {
    this.fileUploadList.splice(index, 1);
    //resetto il valore dell'input file così da poter riaggiungere stesso allegato
    const fileInput = document.getElementById('input-uploader') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  saveOperation(request: DocumentoAllegato): Observable<any> {
    if(!this.isOcrEnable){
      request.flagOcr = undefined;
    }
    // RIMUOVO signedData SOLO DAL PAYLOAD
    const { signedData, ...requestToSave } = request;
    if (this.isMain) {
      console.log("save operation")
      console.log(this.itemSelected);
      // inserimento da sezione Censimento documenti
      if(!!this.isCensimentoDocumenti){
        requestToSave.nomeFile =  (this.separatorePathLogico ? this.separatorePathLogico : '') +  requestToSave.nomeFile;        
      }
      // inserimento da sezione Documentazione allegata
      else {
        requestToSave.nomeFile = this.itemSelected.root ? requestToSave.nomeFile : this.itemSelected.path + this.separatorePathLogico + requestToSave.nomeFile;
      }
      return this.operationService.addDocumentoToSezDocumentiAllegatiOrdinario(this.urlAddDocToSezione, requestToSave, this.sezioneId, this.fascicoloId);
    } else {
      return this.operationService.addDocumentoToEntity(this.urlAddDocToSezione, this.element.id, requestToSave);
    }
  }

  handleSaveResponse(results: Array<{ res: any; file: DocumentoAllegato }>): void {
    this.docAdded(results);
  }

  saveDirName(request: DocumentoAllegato, editNameDir: boolean) {
    const nomeFile = this.itemSelected.root ? request.nomeFile : this.itemSelected.path + this.separatorePathLogico + request.nomeFile;
    request = {
      ...request,
      nomeFile
    };
    // Prima di salvare: controllo duplicati solo per le cartelle
    const cartellaEsistente = this.entityList.some(item =>
      (!item.refDocumentale) &&  // Deve essere una cartella
      (item.nomeFile === request.nomeFile) // Deve avere lo stesso nome
    );

    if (cartellaEsistente) {
      this.modalNotifyService.messaggioCustom(
        "Nome cartella già esistente",
        "Attenzione!"
      );
      return; // Blocco il salvataggio
    }
    if (editNameDir) { // modifica nome dir
      const requestDir = {
        ...this.documento,
        nomeFile,
        titolo: nomeFile
      };
      this.operationService.updateMetadatiDir(this.urlAddDocToSezione, requestDir, this.sezioneId)
        .subscribe(response => {
          if (response.returnCode === 'OK') this.onReturnCallback.emit({response: response});
        });
    } else {
      this.operationService.addDocumentoToSezDocumentiAllegatiOrdinario(this.urlAddDocToSezione, request, this.sezioneId, this.fascicoloId)
        .subscribe(response => { 
          if (response.returnCode === 'OK') this.onReturnCallback.emit({response: response});
        });
    }
  }

  docAdded(results: Array<{ res: any; file: DocumentoAllegato }>) {
    this.itemSelectedCorrente = this.itemSelected;
    console.log("docAdded");
    const metadatiObs: Observable<any>[] = [];
    results.forEach(({ res: response, file: request }) => {
      if (response.returnCode !== 'OK') return;
      let documento: DocumentoAllegato | null = null;
      
      if (response.sezione?.documentiAggregati) { // Sezione Fascicolo Dati Generali
        this.isSezioneDatiGen = true;
        const idx = response.sezione?.documentiAggregati.findIndex(d => d.refDocumentale === request.refDocumentale);
        if (idx >= 0) documento = response.sezione.documentiAggregati[idx];
      } else if (this.nomeResponse && response[this.nomeResponse] && response[this.nomeResponse].documenti) { // Altre sezioni
        this.isSezioneDatiGen = false;
        const idx = response[this.nomeResponse].documenti.findIndex(d => d.refDocumentale === request.refDocumentale);
        if (idx >= 0) documento = response[this.nomeResponse].documenti[idx];
      }

      if (documento) {
        metadatiObs.push(this.updateMetadati(documento));
      }
    });

    if (!metadatiObs.length) {
      this.onReturnCallback.emit(null);
      return;
    }

    forkJoin(metadatiObs).subscribe(responses => {
      this.onReturnCallback.emit(responses[responses.length - 1]);
      this.viewManager.emitEvent(responses[responses.length - 1].sezione);
    });

  }

  updateMetadati(documentoUpdated: DocumentoAllegato): Observable<any> {
    const request: UpdateMetadatiDocumentoRequest = new UpdateMetadatiDocumentoRequest();
    request.documento = { ...documentoUpdated };
    console.log("updateMetadati")
    //NESSUNO SEMBRA IMPOSTARE "sezioneForMetadati"
    //INOLTRE A QUESTO LIVELLO LE INFO CHE SERVONO SONO GI� NEL FASCICOLO
    // QUINDI COMMENTO L IF SEGUENTE
    //    if (this.isSezioneDatiGen && this.sezioneForMetadati) {
    //      request.dataInput = new DataInput(this.sezioneForMetadati.praticaId,
    //                                        this.sezioneForMetadati.fascicoloId,
    //                                        this.sezioneForMetadati.posizionePratica,
    //                                        this.sezioneForMetadati.posizioneFascicolo,
    //                                        this.sezioneForMetadati.tipoPraticaId);
    //      this.operationService.updateMetadatiDocumento(request).subscribe(response => this.docUpdated(response));
    //
    //    } else

    if (this.fascicolo && this.fascicolo.praticaBase) {
      request.dataInput = new DataInput(this.fascicolo.idParent,
        this.fascicolo.id,
        this.fascicolo.praticaBase.posizione,
        this.fascicolo.posizione,
        this.fascicolo.praticaBase.tipoPratica.id);
    }
    return this.operationService.updateMetadatiDocumento(request)
  }

  docUpdated(response) {
    if (response.returnCode === 'OK') {
      console.log('update metadati ok!!! ;-)');
      this.onReturnCallback.emit(response);
    } else {
      console.log('update metadati ko :"[');
    }
  }

  onSearchChange(files: any) {
    if (!files?.length) return;

    this.loading = true;
    this.spinner.show();
    this.filesChangeEmiter.emit(files);

    const uploads$ = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      this.valid_files.push(file);

      const payload$ = this.fileManager.getPayloadFile(file).pipe(
      switchMap(payload =>
        this.uploadFile(payload, i === files.length - 1).pipe(
          catchError(err => {
            console.error('Errore file:', err);

            return of({
              error: true,
              fileName: file.name
            });
          })
        )
      )
    );

      uploads$.push(payload$);
    }

    forkJoin(uploads$).subscribe({
      next: (responses) => {
        responses.forEach(res => {
          if (res && res.fileData) {
            this.setFileDataRequest(res.fileData);
            this.fileUploaded = true;
            this.fileUploadedName = res.fileData.nomeFile;
            this.onReturn.emit(res.fileData);
          }
        });
      },
      error: err => {
        console.error('Errore durante upload multiplo', err);
      },
      complete: () => {
        this.loading = false;
        this.spinner.hide();
      }
    });
  }


  loadMe() {
    this.loading = true;
  }

  getBuffer(fileData) {
  	return function(resolve) {
        var reader = new FileReader();
        reader.readAsArrayBuffer(fileData);
        reader.onload = function() {
          let arrayBuffer = reader.result;
          var bytes = new Uint8Array(arrayBuffer as ArrayBuffer);
          resolve(bytes);
        }
    }
  }


  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      console.log("evt1")
    }
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    console.log("evt2")
  }

  @HostListener('drop', ['$event'])
  public onDrop(evt) {
    this.loading = true;
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;

    if (files.length > 0) {
      this.filesChangeEmiter.emit(files);
      this.spinner.show();

      const uploadObservables = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.valid_files.push(file);
        const upload$ = this.fileManager.getPayloadFile(file).pipe(
          switchMap(payload =>
            this.uploadFile(payload, i === files.length - 1).pipe(
              catchError(err => {
                console.error('Errore file:', err);
                return of({ error: true, fileName: file.name });
              })
            )
          ),
          tap(res => {            
            if ('fileData' in res && res.fileData) {
              this.setFileDataRequest(res.fileData);
              this.fileUploaded = true;
              this.fileUploadedName = res.fileData.nomeFile;
              this.onReturn.emit(res.fileData);
            }
          })
        );
        uploadObservables.push(upload$);
      }

      forkJoin(uploadObservables).subscribe({
        next: () => {
          this.loading = false;
          this.spinner.hide();
        },
        error: () => {
          this.loading = false;
          this.spinner.hide();
        }
      });
    }
  }




  uploadFile(payload: { fileData: {}; }, isLastOne?): Observable < FileUploadResponse > {

    return this.http.post<FileUploadResponse>(this.getUrlUploadDocumento(), payload, {withCredentials: true,})
    /* const formData = new FormData();
    formData.append('contenuto', file);
    formData.append('nomeFile', file.name); */
    //return this.http.post<FileUploadResponse>(this.getUrlUploadDocumento(), payload, {withCredentials: true,})

    /*if (this.XSRF == null || this.XSRF === 'undefined' || this.XSRF === '') {
      this.XSRF = this.getXSRFToken();
    }

    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if(isLastOne)
            this.spinner.hide();
          if (xhr.status === 200) {
            resolve(this.fileData = ( < FileUploadResponse > JSON.parse(xhr.response)).fileData);
            console.log('OK upload');
            this.setFileDataRequest(this.fileData);
            this.fileUploaded = true;
            this.fileUploadedName = this.fileData.nomeFile;
            this.onReturn.emit(this.fileData);
          } else {
            console.log('KO upload');
            this.modalNotifyService.customMessage("L'operazione non è andata a buon fine.");
            this.fileUploaded = false;
            this.fileUploadedName = '';
            reject(xhr.response);
          }
        }
      };
      xhr.open('POST', this.getUrlUploadDocumento(), true, 'admincassa');
      xhr.withCredentials = true;
      xhr.setRequestHeader('X-XSRF-TOKEN', this.XSRF);
      let formData = new FormData();
      console.log(file)
      formData.append('contenuto', file);
      formData.append('nomeFile', file.name);
      xhr.send(formData);
      this.loading = false;
    });*/


  }

  getXSRFToken(): string {

    if (this.XSRF == null || this.XSRF === 'undefined' || this.XSRF === '') {
      let tokenXSRF = localStorage.getItem('token'); // recuperaTokenCSRF(ServicePathsSettings.TOKEN_ANTICSRF_PATH, '');
      this.XSRF = tokenXSRF;
    }

    return this.XSRF;

  }
}
